import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { AdCircuit, EditAdCircuit } from "../../../../types";
import {
  Modal,
  ModalBody,
  ModalClose,
  ModalHeader,
  ModalTitle,
} from "../../../UI/Modal";
import AdvertisingCircuitForm from "../AdvertisingCircuitForm";

type Props = {
  adCircuit?: AdCircuit;
  isOpen: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onSubmit: (data: EditAdCircuit) => void;
};

const AdvertisingCircuitModal: FC<Props> = ({
  adCircuit,
  isOpen,
  isSubmitting,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={isOpen} onClose={() => {}}>
      <ModalHeader>
        <ModalTitle>
          {!adCircuit
            ? t("components.common.advertisingCircuitModal.typeNew")
            : t("components.common.advertisingCircuitModal.typeEdit")}
        </ModalTitle>
        <ModalClose onClose={onClose}>x</ModalClose>
      </ModalHeader>
      <ModalBody>
        <AdvertisingCircuitForm
          isSubmitting={isSubmitting}
          editable
          isAdmin
          onSubmit={(data: any) => onSubmit(data)}
          validable={false}
          onCancel={onClose}
          adCircuit={adCircuit}
        />
      </ModalBody>
    </Modal>
  );
};

export default AdvertisingCircuitModal;
